import Flag from '../Flag';
import { types as eventTypes } from '../enums/event';

/** XAxis flag */
class CrosshairFlagX extends Flag {
	_getStyle(args = {}) {
		const returnStyle = this.panel.core.getStyle('flag.crosshair.xAxis');
		const panelStyle = this.panel.params.style;

		// Use fallback values if necessary
		if (!returnStyle.font.family) returnStyle.font.family = panelStyle.yAxis.font.family;
		if (!returnStyle.font.size) returnStyle.font.size = panelStyle.yAxis.font.size;

		return {
			...returnStyle,
			...args.style
		};
	}

	remove() {
		if (this.el.rootBody) this.el.rootBody.remove();
	}

	render(x0, valDate) {
		// Only render with proper date value
		if (!valDate) return;

		const { size: panelSize } = this.panel;

		const panelBottom =
			panelSize.top + // Panel top is already past the top margin, so don't include the top margin
			panelSize.padding.top +
			panelSize.height;


		if (!this.isCustomRender) {
			if (!this.el.rootBody) {
				this.el.rootBody = this.panel.core.rootModchart
					.append('div')
					.attr('class', 'modcharts-flag-xaxis');
			}

			this.el.rootBody
				.html(this.getLabel(valDate))
				.style('top', `${panelBottom}px`)
				.style('left', `${this.getLeft(x0)}px`)
				.style('background-color', this.style.background.color)
				.style('color', this.style.color)
				.style('font-family', this.style.font.family)
				.style('font-size', `${this.style.font.size}px`);

		} else {

			this.eventEmitter.emit(eventTypes[this.eventType.render], {
				date: valDate,
				dateLabel: this.getLabel(valDate),
				id: this.id,
				indicator: this.indicator,
				panel: this.panel,
				panelBottom,
				style: this.style,
				x: x0
			});
		}
	}

	getLeft(x0) {
		const width = this.el.rootBody.node().offsetWidth;
		let left = Math.max(x0 - (width / 2), 0);
		if (left + width > this.panel.size.width) {
			left = this.panel.size.width - width;
		}
		return left;
	}

	getLabel(valDate) {
		let label = this.formatDate(valDate);
		if (this.panel.core.state.isIntraday) {
			label = `${label} ${this.formatTime(valDate)}`;
		}
		return label;
	}

	formatDate(date) {
		return this.panel.core.timeFormat('%x')(date);
	}

	formatTime(date) {
		const core = this.panel.core;
		return core.timeFormat(core.locale.time)(date);
	}

	/**
	 * @returns The appropriate event emitter types
	 * @type {object}
	 */
	get eventType() {
		return {
			render: 'FLAG_RENDER_XAXIS',
			hide: 'FLAG_HIDE_XAXIS',
			show: 'FLAG_SHOW_XAXIS'
		};
	}
}

export default CrosshairFlagX;
